import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import './Header.css';

const Header = () => {
  const { isAuthenticated } = useAdminAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-logo">
          <Link to="/" className="logo-link" onClick={handleNavClick}>
            <img src="/hsfl-logo.svg" alt="HSFL Logo" className="logo-image" />
            <div className="logo-text">
              <h1>HSFL</h1>
              <p className="league-name">Highschool Football League</p>
            </div>
          </Link>
        </div>
        <button 
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`navigation ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={handleNavClick}>Home</Link>
          <Link to="/live" className="nav-link" onClick={handleNavClick}>Live</Link>
          <Link to="/news" className="nav-link" onClick={handleNavClick}>News</Link>
          <Link to="/rankings" className="nav-link" onClick={handleNavClick}>Rankings</Link>
          <Link to="/playoffs" className="nav-link" onClick={handleNavClick}>Playoffs</Link>
          <Link to="/schedule" className="nav-link" onClick={handleNavClick}>Schedule</Link>
          <Link to="/scores" className="nav-link" onClick={handleNavClick}>Scores</Link>
          <Link to="/stats" className="nav-link" onClick={handleNavClick}>Stats</Link>
          <Link to="/weekly-stats" className="nav-link" onClick={handleNavClick}>Weekly Stats</Link>
          <Link to="/awards" className="nav-link" onClick={handleNavClick}>Awards</Link>
          <Link to="/rulebook" className="nav-link" onClick={handleNavClick}>Rulebook</Link>
          <Link to="/vods" className="nav-link" onClick={handleNavClick}>VODs</Link>
          <Link to="/social" className="nav-link" onClick={handleNavClick}>Social Links</Link>
          {isAuthenticated ? (
            <Link to="/admin" className="nav-link admin-link" onClick={handleNavClick}>Admin</Link>
          ) : (
            <Link to="/admin/login" className="nav-link login-link" onClick={handleNavClick}>Login</Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
